import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    screenHeight: 0,
    screenWidth: 0,
    footerData: {
      web_pages: {},
      web_logo: {},
      web_address: {},
      web_email: {},
      web_phone: {},
      web_icp: {},
      web_net: {},
      web_comp_contact: {},
      web_contact: {},
      web_about_img: {},
      web_about_title: {},
      web_comp_vision: {},
      web_about_info: {},
      web_comp_intro: {},
      web_terms: {},
      web_map: {}
    },
    selectData: {
      selectAreaList: [],
      selectIndustry: []
    }
  },
  getters: {
    screenWidth: state => state.screenWidth,
    screenHeight: state => state.screenHeight,
    commonData: state => state.footerData,
    selectAreaList: state => state.selectData.selectAreaList,
    selectIndustry: state => state.selectData.selectIndustry
  },
  mutations: {
    /*
    * 窗口变化更新宽高
    */
    windowResize (state, data) {
      state.screenWidth = data.w
      state.screenHeight = data.h
    },
    // 设置页脚数据
    setFooterData (state, data) {
      state.footerData[data.key] = data.value
    },
    // 缓存筛选下拉框列表
    cacheSelectData (state, data) {
      state.selectData[data.key] = data.value
    }
  },
  // 严格模式
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/utils/store.js